import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";

export const getCategoryApi = createApi({
  reducerPath: "getCategoryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = Cookies.get("authToken");
      if (token) {
        headers.set("Authorization", `${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    allCategoryapi: builder.query({
      query: () => `/all-category`,
    }),
  }),
});

export const { useAllCategoryapiQuery } = getCategoryApi;
